import { render, staticRenderFns } from "./RelevanceDialog.vue?vue&type=template&id=23cdfa2c&scoped=true&"
import script from "./RelevanceDialog.vue?vue&type=script&lang=js&"
export * from "./RelevanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelevanceDialog.vue?vue&type=style&index=0&id=23cdfa2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cdfa2c",
  null
  
)

export default component.exports